<script>
import helpers from "@/packages/cassandra-base/utilities/helpers/helper.js";
export default {
  name: "RecallForm",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    employeeNo: {
      type: String,
      required: true,
    },
    record: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      valid: true,
      dateMenu: false,
      form: {
        applicationCode: "",
        returnDate: null,
        reason: "",
        requestedByEmployeeNo: this.employeeNo,
        recallNo: "",
      },
      rules: {
        required: (v) => !!v || "This field is required",
      },
    };
  },

  mounted() {
    this.$store.dispatch("leaveRecall/getLeaveApplicationOptions", {
      employee: this.employeeNo,
    });
  },

  computed: {
    computedShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },

    applicationOptions: function () {
      const records = this.$store.getters["leaveRecall/leaveRecallGetters"](
        "leaveApplicationOptions"
      );

      return records.map((record) => ({
        code: record.application_code,
        description: `${this.getEmployeeName(record.leavemployee)} (${
          record.employee_no
        }) - ${record.leaveCodeDescription} (${record.application_code})`,
      }));
    },
  },

  methods: {
    closeForm() {
      this.$refs.form.reset();
      this.$emit("close");
    },

    submit() {
      const isValid = this.$refs.form.validate();

      if (!isValid) return;

      this.$store
        .dispatch("leaveRecall/saveRecall", this.form)
        .then(() => {
          this.closeForm();
        })
        .catch((error) => {
          console.log("Error saving leave recall", error.response.data);
        });
    },

    getEmployeeName: function (employee) {
      return helpers.getEmployeeName(employee);
    },
  },

  watch: {
    record: function () {
      if (this.record) {
        this.form.applicationCode = this.record.applicationCode;
        this.form.returnDate = this.record.returnDate;
        this.form.reason = this.record.reason;
        this.form.requestedByEmployeeNo = this.record.requestedByEmployeeNo;
        this.form.recallNo = this.record.recallNo;
      }
    },
  },
};
</script>

<template>
  <v-dialog v-model="computedShow" persistent max-width="600px">
    <v-card>
      <v-card-title class="text-h5"> Recall Form </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid">
            <v-select
              v-model="form.applicationCode"
              :items="applicationOptions"
              item-value="code"
              item-text="description"
              :rules="[rules.required]"
              label="Select Leave application"
              required
            ></v-select>

            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.returnDate"
                  label="Select Return Date"
                  readonly
                  :rules="[rules.required]"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.returnDate"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>

            <v-textarea
              v-model="form.reason"
              label="Reason for recall"
              outlined
              rows="3"
              maxlength="250"
              dense
              clearable
              hint="250 characters max"
            />

            <v-btn @click="submit" color="blue darken-1" class="mr-4">
              Save
            </v-btn>
            <v-btn @click="closeForm" text> Cancel </v-btn>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
